import React from 'react';
import { FadeIn } from './FadeIn';
import { CalendarIcon, TicketIcon, FileTextIcon, PresentationIcon } from 'lucide-react';
export function Transformation() {
  const steps = [{
    icon: <CalendarIcon className="w-6 h-6 text-padel-dark" data-id="element-237" />,
    title: 'El Lunes',
    text: 'Arrancás sabiendo exactamente qué vas a trabajar con cada grupo. No porque lo pensaste el domingo. Sino porque lo planificaste en 20 minutos el viernes con un sistema que ya tiene todo resuelto.'
  }, {
    icon: <TicketIcon className="w-6 h-6 text-padel-dark" data-id="element-238" />,
    title: 'Al terminar cada clase',
    text: 'Le entregás a tu alumno un ticket con su mejor momento del día y el único foco de la semana. Ese alumno se va con algo en la mano. Y eso que lleva en la mano vale más para la retención que cualquier clase perfecta sin evidencia.'
  }, {
    icon: <FileTextIcon className="w-6 h-6 text-padel-dark" data-id="element-239" />,
    title: 'Al final del mes',
    text: 'Abrís una plantilla, completás los datos que ya registraste semana a semana, y en 15 minutos tenés el informe mensual de cada alumno listo. Se lo mandás por WhatsApp. El alumno lo lee, lo guarda, lo muestra a su pareja. Y el mes siguiente renueva sin que tengas que pedírselo.'
  }, {
    icon: <PresentationIcon className="w-6 h-6 text-padel-dark" data-id="element-240" />,
    title: 'Al final del trimestre',
    text: 'Te sentás con tu alumno, le mostrás el informe completo y le decís: "Acá es donde estabas. Acá es donde estás ahora. Esto es lo que construimos juntos en 3 meses." Y en ese momento, la conversación de precio se vuelve la más fácil que tuviste en años.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-padel-surface relative overflow-hidden" data-id="element-241">
      {/* Glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-padel-lime/5 rounded-full blur-[100px] pointer-events-none" data-id="element-242"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-243">
        <FadeIn data-id="element-244">
          <h2 className="text-3xl sm:text-5xl font-display font-bold text-center text-white mb-16 leading-tight" data-id="element-245">
            Existe una versión de tu semana <br className="hidden sm:block" data-id="element-246" />
            <span className="text-padel-lime" data-id="element-247">
              que se ve completamente diferente.
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-248">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-249">
              <div className="flex flex-col sm:flex-row gap-6 items-start bg-padel-dark border border-padel-muted p-6 sm:p-8 rounded-2xl relative overflow-hidden group hover:border-padel-lime/50 transition-colors" data-id="element-250">
                <div className="absolute left-0 top-0 bottom-0 w-1 bg-padel-muted group-hover:bg-padel-lime transition-colors" data-id="element-251"></div>

                <div className="bg-padel-lime w-12 h-12 rounded-full flex items-center justify-center shrink-0 shadow-[0_0_15px_rgba(197,255,61,0.3)]" data-id="element-252">
                  {step.icon}
                </div>

                <div data-id="element-253">
                  <h3 className="text-xl font-display font-bold text-white mb-2" data-id="element-254">
                    {step.title}
                  </h3>
                  <p className="text-gray-300 leading-relaxed" data-id="element-255">{step.text}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-256">
          <div className="text-center mt-16" data-id="element-257">
            <p className="text-2xl sm:text-3xl font-display font-bold text-white" data-id="element-258">
              Esa versión de tu semana no requiere más horas.{' '}
              <br className="hidden sm:block" data-id="element-259" />
              <span className="text-padel-lime" data-id="element-260">
                Requiere el sistema correcto.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}